import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (name, email, password, role = 'admin') => 
    api.post('/auth/register', { name, email, password, role }),
  getMe: () => api.get('/auth/me'),
};

// User APIs
export const userAPI = {
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
};

// Category APIs
export const categoryAPI = {
  getAll: () => api.get('/categories'),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  delete: (id) => api.delete(`/categories/${id}`),
};

// SubCategory APIs
export const subCategoryAPI = {
  getAll: (categoryId = null) => 
    api.get('/subcategories', { params: categoryId ? { category_id: categoryId } : {} }),
  create: (data) => api.post('/subcategories', data),
  update: (id, data) => api.put(`/subcategories/${id}`, data),
  delete: (id) => api.delete(`/subcategories/${id}`),
};

// Vendor APIs
export const vendorAPI = {
  getAll: (subCategoryId = null) => 
    api.get('/vendors', { params: subCategoryId ? { sub_category_id: subCategoryId } : {} }),
  create: (data) => api.post('/vendors', data),
  update: (id, data) => api.put(`/vendors/${id}`, data),
  delete: (id) => api.delete(`/vendors/${id}`),
};

// Budget Plan APIs
export const budgetPlanAPI = {
  getAll: () => api.get('/budget-plans'),
  getById: (id) => api.get(`/budget-plans/${id}`),
  create: (data) => api.post('/budget-plans', data),
  update: (id, data) => api.put(`/budget-plans/${id}`, data),
  delete: (id) => api.delete(`/budget-plans/${id}`),
  downloadPdf: (id) => api.get(`/budget-plans/${id}/pdf`, { responseType: 'blob' }),
  sendEmail: (id, toEmail) => api.post(`/budget-plans/${id}/email`, { to_email: toEmail, budget_plan_id: id }),
};

// Vendor Match API
export const vendorMatchAPI = {
  match: (data) => api.post('/vendor-match', data),
};

// Logs API
export const logsAPI = {
  getDates: () => api.get('/logs/dates'),
  getContent: (date) => api.get(`/logs/${date}`),
};

export default api;
